import{jsx as o}from"react/jsx-runtime";import e from"./Marked.module.scss.js";const m=({str:r})=>o("mark",{className:e.highlightedBackground,children:r});export{m as Marked};
//# sourceMappingURL=Marked.js.map
